module.exports = __webpack_public_path__ + "img/weekstar.bdeac87d.png";